<div
  dndEffectAllowed="copyMove"
  dndType="group"
  (dndStart)="dragstart()"
  (dndEnd)="dragend()"
  [dndDraggable]="listGroupTask"
  (dndDrag)="drag($event)"
  class="list-tasks-group"
>
  <div [permission]="dragPermissions" dndHandle class="list-tasks-group__draggable">
    <img width="15" src="./assets/img/ic-sortdragchange.svg" alt="drag-drop" />
  </div>

  <div class="list-tasks-group__wrapper">
    <div class="list-tasks-group__header">
      <div class="list-tasks-group__header__title">
        <h4 class="d-flex align-items-center">
          <div class="mr-2 list-tasks-group__header__title-edit">
            <img
              [ngClass]="{
                pointer: !listGroupTask?.taskGroup?.immutable,
                'not-allowed': listGroupTask?.taskGroup?.immutable
              }"
              [src]="
                './assets/img/ic-edit-' + (listGroupTask?.taskGroup?.immutable ? '3-grey' : '3') + '.svg'
              "
              (click)="!listGroupTask?.taskGroup?.immutable ? editGroupName(listGroupTask) : null"
              alt="edit"
            />
          </div>
          {{
            listGroupTask.taskGroup.name === 'general'
              ? ('ProjectTasks.TaskGroup.general' | translate)
              : (listGroupTask.taskGroup.name | listGroupTranslate)
          }}
        </h4>
        <span>
          {{
            (listGroupTask.completedCount !== undefined
              ? listGroupTask.completedCount
              : listGroupTask.completedTasks.length) +
              '/' +
              (listGroupTask.count !== undefined
                ? listGroupTask.count
                : listGroupTask.allCount !== undefined
                  ? listGroupTask.allCount
                  : listGroupTask.currentAllCount !== undefined
                    ? listGroupTask.currentAllCount
                    : 0)
          }}
        </span>
      </div>
      <div
        [permission]="{ group: PermissionsGroups.TASKS, action: 'ADD' }"
        class="list-tasks-group__header__actions"
      >
        <app-button
          *ngIf="!(isDelegatedTasksTab$ | async)"
          class="ml-2"
          (onClick)="addTask(listGroupTask?.taskGroup)"
          [config]="{
            type: ButtonTypes.NEW_PRIMARY_BLUE,
            size: ButtonSize.SMALL,
            smSize: ButtonSize.SMALL,
            prependSrc: '/assets/img/ic-plus-add.svg'
          }"
        >
        </app-button>
      </div>
    </div>
    <div
      class="list-tasks-group__content"
      #dropzone
      (dndDrop)="dropEvent($event, listGroupTask)"
      [dndDropzone]="['task']"
    >
      <div dndPlaceholderRef class="dndPlaceholder"></div>
      <ng-container #tasksContainer></ng-container>

      <div
        class="d-flex flex-column list-tasks-group__completed"
        [ngClass]="{ hidden: isEmptyCompleted || !listService?.filtersForm?.get('[show_completed]')?.value }"
      >
        <h5 class="list-tasks-group__content__completed-title">
          {{ 'ProjectTasks.TaskGroup.completedTasks' | translate }}
        </h5>
        <ng-container #completedContainer></ng-container>
      </div>

      <div
        class="d-flex flex-column list-tasks-group__cancelled"
        [ngClass]="{ hidden: isEmptyCancelled || !listService?.filtersForm?.get('[show_cancelled]')?.value }"
      >
        <h5 class="list-tasks-group__content__cancelled-title">
          {{ 'ProjectTasks.TaskGroup.cancelledTasks' | translate }}
        </h5>
        <ng-container #cancelledContainer></ng-container>
      </div>
    </div>
  </div>
</div>
